// InstallPrompt — one-time nudge for iOS Safari users to add TMCChat to the Home Screen.
// iOS has no beforeinstallprompt event, so we can only instruct (Share → Add to Home Screen).
// Shows only in an iOS browser tab (not when already installed/standalone) and hides for good
// once dismissed. Installing (→ standalone) also removes it automatically.
import { useState } from "react";
import Icon from "./Icon.jsx";

const isIos = () =>
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1); // iPadOS reports as Mac
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

const DISMISS_KEY = "tmc.installPrompt.dismissed";

export default function InstallPrompt() {
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });
  if (hidden || !isIos() || isStandalone()) return null;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, "1"); } catch { /* private mode — non-fatal */ }
    setHidden(true);
  };

  return (
    <div className="install-banner" role="dialog" aria-label="Add TMCChat to your Home Screen">
      <span className="install-banner__icon"><img src="/icons/icon-180.png" alt="" /></span>
      <div className="install-banner__text">
        <strong>Add TMCChat to your Home Screen</strong>
        <span>Tap <Icon name="share-ios" className="ic--sm" /> then <b>Add to Home Screen</b> — for notifications and a full-screen app.</span>
      </div>
      <button type="button" className="install-banner__x" onClick={dismiss} aria-label="Dismiss">
        <Icon name="close" className="ic--sm" />
      </button>
    </div>
  );
}
